module.exports = __webpack_public_path__ + "img/IDCBLALA.ad0ded7b.jpg";